import { render, staticRenderFns } from "./ProjectCompany.vue?vue&type=template&id=1c9c9302&"
import script from "./ProjectCompany.vue?vue&type=script&lang=js&"
export * from "./ProjectCompany.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCombobox,VSelect,VTextField})
